var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShowToTop && !_vm.$route.meta.hideScrollTop)?_c('div',{staticClass:"toTop",on:{"click":_vm.scrollToTop}},[_c('i',{staticClass:"iconfont icon-huidaodingbu"}),_c('div',{staticClass:"text"},[_vm._v("回到顶部")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }